import React from 'react';

const About = () => {
  return (
    <div className="serviceInfo">
      <span className="serviceInfoContainer">
        <h3 className="serviceTitle">Sorry. Under Construction...</h3>
      </span>
    </div>
  );
};

export default About;